import axios from '@/libs/api.request'

/**
 * 获取培训鉴定信息列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页条数
 * @param {string} params.keyword - 搜索关键词（可选）
 * @param {number} params.type - 类型 0=培训 1=鉴定（可选）
 */
export const getTrainList = (params = {}) => {
  return axios.request({
    url: '/v2/train/info/',
    method: 'get',
    params
  })
}

/**
 * 创建培训鉴定信息
 * @param {Object} data - 培训鉴定信息数据
 * @param {string} data.trainname - 培训/鉴定名称（必填）
 * @param {string} data.trainaddress - 培训/鉴定地址（必填）
 * @param {string} data.latitude - 纬度（可选）
 * @param {string} data.longitude - 经度（可选）
 * @param {string} data.code - 编码（可选）
 * @param {string} data.content - 内容（可选）
 * @param {string} data.linkman - 联系人（可选）
 * @param {number} data.type - 类型 0=培训 1=鉴定（可选，默认0）
 * @param {string} data.phone - 联系电话（可选）
 */
export const createTrain = (data) => {
  return axios.request({
    url: '/v2/train/info/',
    method: 'post',
    data
  })
}

/**
 * 更新培训鉴定信息
 * @param {Object} data - 更新数据
 * @param {number} data.id - 培训鉴定信息ID（必填）
 * @param {string} data.trainname - 培训/鉴定名称（可选）
 * @param {string} data.trainaddress - 培训/鉴定地址（可选）
 * @param {string} data.latitude - 纬度（可选）
 * @param {string} data.longitude - 经度（可选）
 * @param {string} data.code - 编码（可选）
 * @param {string} data.content - 内容（可选）
 * @param {string} data.linkman - 联系人（可选）
 * @param {number} data.type - 类型 0=培训 1=鉴定（可选）
 * @param {string} data.phone - 联系电话（可选）
 */
export const updateTrain = (data) => {
  return axios.request({
    url: '/v2/train/info/',
    method: 'put',
    data
  })
}

/**
 * 删除培训鉴定信息（逻辑删除）
 * @param {Object} data - 删除数据
 * @param {number} data.id - 培训鉴定信息ID（必填）
 */
export const deleteTrain = (data) => {
  return axios.request({
    url: '/v2/train/info/',
    method: 'delete',
    data
  })
}

/**
 * 导入培训鉴定信息
 * @param {FormData} formData - 表单数据
 */
export const importTrain = (formData) => {
  return axios.request({
    url: '/v2/train/info/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 导出培训鉴定信息
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词（可选）
 * @param {number} params.type - 类型 0=培训 1=鉴定（可选）
 */
export const exportTrain = (params = {}) => {
  return axios.request({
    url: '/v2/train/info/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 下载导入模板
 */
export const getTrainTemplate = () => {
  return axios.request({
    url: '/v2/train/info/template',
    method: 'get',
    responseType: 'blob'
  })
}
